<script setup lang="ts">
import DropdownMenu from '@/components/ui/dropdown-menu/DropdownMenu.vue'
import DropdownMenuContent from '@/components/ui/dropdown-menu/DropdownMenuContent.vue'
import DropdownMenuGroup from '@/components/ui/dropdown-menu/DropdownMenuGroup.vue'
import DropdownMenuItem from '@/components/ui/dropdown-menu/DropdownMenuItem.vue'
import DropdownMenuSeparator from '@/components/ui/dropdown-menu/DropdownMenuSeparator.vue'
import DropdownMenuTrigger from '@/components/ui/dropdown-menu/DropdownMenuTrigger.vue'
import { useTranslateKey } from '@/lib/utils'
import { navigateTo } from '@/router/utils'
import { RouteName, Routes } from '@/router/routes'
import { useUserStore } from '@/stores/userStore'
import Button from '@/components/ui/button/Button.vue'
import { MoreHorizontalIcon } from 'lucide-vue-next'

const emit = defineEmits<{
  navigate: []
}>()

const { translateKey } = useTranslateKey()
const userStore = useUserStore()

const navigateToRouteHandler = (routeName: RouteName) => {
  emit('navigate')
  navigateTo(routeName)
}
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button class="ml-auto" variant="ghost" data-testid="sidebar-dropdown-trigger">
        <MoreHorizontalIcon class="h-4 w-4" />
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent class="z-50 w-56">
      <DropdownMenuGroup>
        <DropdownMenuItem
          data-testid="sidebar-dropdown-accountSettings"
          @click="navigateToRouteHandler(Routes.PROFILE)"
        >
          <span>{{ translateKey('accountSettings') }}</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          v-if="userStore.isOrgaAdmin"
          @click="navigateToRouteHandler(Routes.PROFILE_ORGANISATION)"
        >
          <span>{{ translateKey('organisation') }}</span>
        </DropdownMenuItem>
      </DropdownMenuGroup>
      <DropdownMenuGroup v-if="userStore.isAdmin">
        <DropdownMenuItem @click="navigateToRouteHandler(Routes.ADMIN_USERS)">
          <span>{{ translateKey('adminDashboard') }}</span>
        </DropdownMenuItem>
      </DropdownMenuGroup>
      <DropdownMenuSeparator />
      <DropdownMenuItem @click="navigateToRouteHandler(Routes.IMPRINT)">
        <span>{{ translateKey('imprint') }}</span>
      </DropdownMenuItem>
      <DropdownMenuItem @click="navigateToRouteHandler(Routes.PRIVACY)">
        <span>{{ translateKey('privacy') }}</span>
      </DropdownMenuItem>
      <DropdownMenuItem @click="navigateToRouteHandler(Routes.TOS)">
        <span>{{ translateKey('tos') }}</span>
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem data-testid="sidebar-logout-item" @click="navigateTo('logout')">
        <span>{{ translateKey('logOut') }}</span>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
